import { FC } from "react";

interface EmployerRegistrationFormProps {
  onSuccess?: () => void;
}

export const EmployerRegistrationForm: FC<EmployerRegistrationFormProps> = ({ onSuccess = () => undefined }) => {
  return <div>EmployerRegistrationForm</div>;
};